import { TaskCompleteInput, TaskOutcome } from '@api/generated/graphql';

/**
 * Build the TaskCompleteInput payload for `completeOutboundLeadTask`.
 *
 * Mirror of the BFF contract: when both `jobId` (entered by the CSR) and
 * `pcsConversationSid` (captured on `phone.pcs.conversation.fetched`) are
 * present, attach them as `jobBooking` so the BFF can write a JobBooking
 * activity to the interaction. The BFF decides when it's *required*; the
 * client just forwards what it has.
 */
export const buildCompleteTaskInput = (params: {
  outcome: TaskOutcome;
  notes?: string;
  jobId?: string;
  pcsConversationSid?: string;
}): TaskCompleteInput => {
  const { outcome, notes, jobId, pcsConversationSid } = params;
  const input: TaskCompleteInput = { outcome, notes };
  if (jobId && pcsConversationSid) {
    input.jobBooking = {
      channelId: pcsConversationSid,
      jobId,
    };
  }
  return input;
};
